(function () {
  if (!/\/products\//.test(window.location.pathname)) return;

  function wire(root) {
    const carousel = root.querySelector('scroll-carousel');
    if (!carousel || carousel.dataset.navWired) return;
    carousel.dataset.navWired = '1';

    const prev = root.querySelector('carousel-prev-button button, .prev-next-button--prev');
    const next = root.querySelector('carousel-next-button button, .prev-next-button--next');
    const step = () => Math.max(carousel.clientWidth * 0.9, 200);

    function refresh() {
      const maxScroll = carousel.scrollWidth - carousel.clientWidth - 2;
      if (prev) prev.disabled = carousel.scrollLeft <= 2;
      if (next) next.disabled = carousel.scrollLeft >= maxScroll;
    }

    if (prev) prev.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      carousel.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      carousel.scrollBy({ left: step(), behavior: 'smooth' });
    });

    carousel.addEventListener('scroll', () => requestAnimationFrame(refresh), { passive: true });
    refresh();
  }

  let done = false;
  function tryWire() {
    const root = document.querySelector('product-recommendations');
    if (root && root.querySelector('scroll-carousel') && !done) {
      done = true;
      obs.disconnect();
      wire(root);
    }
  }
  const obs = new MutationObserver(tryWire);
  obs.observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') tryWire();
  else document.addEventListener('DOMContentLoaded', tryWire);
})();